/**
 * Credit Card Data Exports
 *
 * This file provides a clean interface to the autogenerated credit card data.
 * It exports both CreditCardData and CreditCardDataFiltered for backward compatibility.
 *
 * IMPORTANT: Do not import directly from __autogenerated__/cards/CreditCardData.ts
 * Always import from this file instead.
 */

// Import dependencies for filtering
import { CreditCardData as AllCreditCardData } from './__autogenerated__/cards/CreditCardData';
import { enabledCards } from './enabledCards';
import { CreditCard } from './__autogenerated__/types/CreditCard';

// Re-export the main CreditCardData (unfiltered)
export { CreditCardData } from './__autogenerated__/cards/CreditCardData';

// Create filtered version that only includes enabled cards
export const CreditCardDataFiltered = Object.fromEntries(
  Object.entries(AllCreditCardData).filter(([cardId]) =>
    enabledCards.includes(cardId as CreditCard)
  )
) as typeof AllCreditCardData;

// Re-export the CardData type
export type { CardData } from '../types/CardData';
